import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import {
  SectionNotification,
  SectionNotificationType,
} from 'wix-ui-tpa/cssVars';
import { classes } from './AddonsNotification.st.css';
import { ServiceData, SlotService } from '../../../../utils/state/types';
import { mapToArray } from '../../../../utils';
import { PaymentType } from '../../../../types/types';

interface AddonsNotificationProps {
  serviceData: ServiceData;
}

export const AddonsNotification: React.FC<AddonsNotificationProps> = ({
  serviceData,
}) => {
  const { t } = useTranslation();
  const singleService = mapToArray<SlotService>(serviceData.slotServices)[0];
  const hasSelectedAddons =
    singleService.selectedAddons &&
    Object.keys(singleService.selectedAddons).length > 0;

  const showPlanMessage =
    hasSelectedAddons &&
    mapToArray<SlotService>(serviceData.slotServices).some(
      (slotService: SlotService) =>
        slotService.selectedPaymentOption?.type === PaymentType.BUY_PLAN &&
        !slotService.selectedPaymentOption?.creditRemain,
    );

  if (!showPlanMessage) {
    return null;
  }

  return (
    <SectionNotification
      type={SectionNotificationType.default}
      className={classes.planMessage}
      data-hook="addons-plan-message"
    >
      <SectionNotification.Text>
        {t('app.bookings-form.add-ons.plan-message')}
      </SectionNotification.Text>
    </SectionNotification>
  );
};
